module.exports = __webpack_public_path__ + "img/notifications.c00dac88.svg";